import React from 'react';
import styles from './BuyCard.module.css';
import cn from 'classnames';

interface BuyCardProps {
  fullPaymentAmount: number;
  discountPercentage: number;
  discountAmount: number;
  installmentYears: number;
  downPayment: number;
  monthlyPayment: number;
  numberOfPayments: number;
  discountFull: number;
  installmentPrice: number;
  onCardSelect: (option: 'full' | 'installment') => void;
  selectedOption: 'full' | 'installment';
}

const BuyCard: React.FC<BuyCardProps> = ({
  fullPaymentAmount,
  discountPercentage,
  discountAmount,
  installmentYears,
  downPayment,
  monthlyPayment,
  numberOfPayments,
  discountFull,
  installmentPrice,
  onCardSelect,
  selectedOption,
}) => {
  return (
    <div className={styles.payment_options}>
      <div
        className={cn(styles.payment_card, styles.full_payment, {
          [styles.selected]: selectedOption === 'full',
        })}
        onClick={() => onCardSelect('full')}
      >
        <div className={styles.payment_header}>
          <p className='text_subheaders_sh2'>Полная оплата</p>
        </div>
        <div className={styles.discount_info}>
          <div className={cn('text_captions_c1', styles.discount_label)}>Скидка</div>
          <div className={styles.discount_amount}>
            <span className={cn('text_subheaders_sh2', styles.amount)}>
              от {discountAmount.toLocaleString()} ₽
            </span>
          </div>
        </div>
      </div>

      <div
        className={cn(styles.payment_card, styles.installment, {
          [styles.selected]: selectedOption === 'installment',
        })}
        onClick={() => onCardSelect('installment')}
      >
        <div className={styles.payment_header}>
          <p className='text_subheaders_sh2'>Рассрочка</p>
        </div>
        <div className={styles.payment_details}>
          <div className={styles.payment_column}>
            <div className={cn('text_captions_c1', styles.payment_label)}>Первый взнос</div>
            <div className={cn('text_subheaders_sh2', styles.payment_amount)}>
              <span>от {downPayment.toLocaleString()} ₽</span>
              <div className={cn(styles.progress_bar, styles.active)}></div>
            </div>
          </div>
          <div className={styles.payment_column}>
            <div className={cn('text_captions_c1', styles.payment_label)}>Далее {numberOfPayments} ежемесячных платежей</div>
            <div className={cn('text_subheaders_sh2', styles.payment_amount)}>
              <span>от {monthlyPayment.toLocaleString()} ₽</span>
              <div className={styles.progress_bar}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyCard;
